import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOfertaCompleto } from '@/contexts/OfertaContext';
export function OfertaRoute({ atual, completo }: { atual: ReactNode; completo: ReactNode }) {
  return useOfertaCompleto() ? completo : atual;
}
// Tricô está oculto para todas as contas (dados preservados no banco).
export function FerramentaRoute(_props: { children: ReactNode }) {
  return <Navigate to="/painel" replace />;
}
